import React from "react";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button } from "react-bootstrap";

const InvoiceFilter = ({
  t,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleFilterInvoice,
  setactivePagination,
  handleClearFilter,
  loading,
  invoiceNumber,
}) => {
  return (
    <div>
      <div className="row m-0 mb-2 invoices-row">
        <div className="col-md-3 pl-0 col-sm-6 mb-2">
          <DatePicker
            render={
              <InputIcon
                placeholder={t("From")}
                style={{
                  border:
                    !loading && fromDate > toDate ? "1px solid #dc3545" : "",
                }}
              />
            }
            value={fromDate}
            onChange={(date) => {
              setFromDate(new Date(date));
              if (!toDate) {
                setToDate(new Date());
              }
            }}
          />

          {!loading && fromDate > toDate && (
            <p
              className="form-text text-danger mb-0 ml-1"
              style={{ fontSize: "0.8rem" }}
            >
              {t("End date must be higher than start date")}
            </p>
          )}
          {!loading && toDate && !fromDate && (
            <p
              className="form-text text-danger mb-0 ml-1"
              style={{ fontSize: "0.8rem" }}
            >
              {t("Please Select The Start Date")}
            </p>
          )}
        </div>

        <div className="col-md-3 pl-0 col-sm-6 mb-2">
          <DatePicker
            color="red"
            render={<InputIcon placeholder={t("To")} />}
            value={toDate}
            className="ml-2"
            onChange={(date) => {
              setToDate(new Date(date));
            }}
          />
        </div>

        <Button
          variant="outline-primary"
          className="mb-2 h-25"
          onClick={() => {
            handleFilterInvoice();
            setactivePagination(1);
          }}
        >
          {t("Search")}
        </Button>

        <Button
          disabled={!invoiceNumber && (!fromDate && !toDate)}
          variant="outline-primary"
          className="mb-2 ml-2 h-25"
          onClick={() => {
            handleClearFilter();
            setactivePagination(1);
          }}
        >
          {t("Clear Filters")}
        </Button>
      </div>
    </div>
  );
};

export default InvoiceFilter;
